// Vite entry point for MuseMinded Gemini

// CRITICAL: Import globals FIRST - sets window.jQuery before Bootstrap loads
import './globals';

// Import styles
import '../styles/main.scss';

// Core Angular
import angular from 'angular';

// Bootstrap JS (needs jQuery global)
import 'bootstrap-sass/assets/javascripts/bootstrap';

// Angular plugins
import 'angular-animate';
import 'angularjs-toaster';
import 'ng-file-upload';
import 'ui-select';
import 'angular-websocket';
import 'angular-actioncable';
import 'angular-xeditable';
import 'angular-trix';
import 'ng-tags-input';
import 'angular-ui-router';

// Pikaday
import 'pikaday';
import 'pikaday-angular';

// Sweetalert
import swal from 'sweetalert';
window.swal = swal;

// Trix editor
import 'trix';

// Dragula
import angularDragula from 'angularjs-dragula';

// Local assets (these may need adjustment based on actual file structure)
import '../assets/angular-cookie';
import '../assets/ng-token-auth.min';

// App modules
import constants from './constants';
import onConfig from './on_config';
import qConfig from './q_config';
import ngTokenConfig from './ng_token_config';
import onRun from './on_run';
import './templates';
import './filters';
import './controllers';
import './services';
import './directives';

// Create and bootstrap application
const requires = [
  'ui.router',
  'templates',
  'app.filters',
  'app.controllers',
  'app.services',
  'app.directives',
  'ng-token-auth',
  'ngAnimate',
  'toaster',
  'ngFileUpload',
  'ui.select',
  'pikaday',
  'ngActionCable',
  'xeditable',
  'angularTrix',
  'ngTagsInput',
  angularDragula(angular)
];

// Mount on window for testing
window.app = angular.module('app', requires);

angular.module('app').constant('AppSettings', constants);
angular.module('app').config(ngTokenConfig);
angular.module('app').config(onConfig);
angular.module('app').config(qConfig);
angular.module('app').run(onRun);

angular.bootstrap(document, ['app'], {
  strictDi: true
});
